import type { FC } from 'react';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import {
  getActiveSection,
  getIsDiscountsSection,
} from '../../../selectors/studio';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { TabItem } from '@wix/da-ds/pkg/Tabs';
import { StudioSection } from '../../../types/store';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';

import s from './ShopTabs.scss';

interface Props {}

const ShopTabs: FC<Props> = () => {
  const activeTab = useSelector(getActiveSection);
  const isDiscountsSection = useSelector(getIsDiscountsSection);
  const { t } = useTranslation();
  const isEarningsEnabled = useFlag('studio_earnings');

  const currentDiscountSectionIndex = isDiscountsSection
    ? activeTab
    : StudioSection.SELLER_DISCOUNTS_ACTIVE_AND_SCHEDULED;

  return (
    <UnderlinedTabs
      className={s['root']}
      uniformTabWidth
      items={
        [
          {
            label: t('studio.navigation.tabs.products_lobby'),
            index: StudioSection.PRODUCTS_LOBBY,
            href: Url.studio({ products: 'root' }),
          },
          {
            label: t('studio.navigation.tabs.shop_reports'),
            index: StudioSection.SHOP_REPORTS,
            href: Url.studio({ section: 'shop-reports' }),
          },
          {
            label: t('studio.navigation.tabs.discounts'),
            index: currentDiscountSectionIndex,
            href: Url.studio({
              section: 'discounts',
              discounts: 'active_and_scheduled',
            }),
          },
          isEarningsEnabled && {
            label: t('studio.navigation.tabs.earnings'),
            index: StudioSection.EARNINGS,
            href: Url.studio({ section: 'earnings' }),
          },
        ].filter(Boolean) as TabItem[]
      }
      activeIndex={activeTab}
    />
  );
};
ShopTabs.displayName = 'ShopTabs';

export default ShopTabs;
